import React from 'react';
import PropTypes from 'prop-types';

const HeaderIcon = ({ isSelected = false, src, onClick }) => {
  const style = {
    width: '15px',
    height: '15px',
  };

  const selected = {
    border: '1px solid rgb(23, 232, 128)',
  };

  const containerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '25px',
    height: '25px',
    cursor: 'pointer',
    outline: 'none',
  };

  return (
    <div
      role="button"
      tabIndex={-1}
      style={Object.assign({}, containerStyle, isSelected && selected)}
      onClick={onClick}
    >
      <img style={style} src={src} alt="" />
    </div>
  );
};

HeaderIcon.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  src: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default HeaderIcon;



// WEBPACK FOOTER //
// ./src/components/Project/ProjectList/ProjectListHeader/HeaderIcon/HeaderIcon.js